import React from "react";
import Chart from "react-apexcharts";
import { useGatewayStats } from "../../../Payments/hooks/useGatewayStats";


const GatewayDistributionChart: React.FC = () => {
  const gatewayStats = useGatewayStats();

  console.log("gatewayStats", gatewayStats);
  const options: ApexCharts.ApexOptions = {
    chart: {
      type: "donut",
    },
    labels: ["Airtel Money", "TNM Mpamba", "PayPal", "Stripe"],
    colors: ['#FF0000', '#309B47', '#0000FF', '#163A5D'],
    legend: {
      position: "left",
      labels: {
        colors: "#fff",
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 300,
          },
          legend: {
            position: "bottom",
          },
        },
      },
    ],
    dataLabels: {
      enabled: true,
    },
    plotOptions: {
      pie: {
        donut: {
          labels: {
            show: true,
            name: {
              show: true,
              color: "#fff",   // label color for slice name
            },
            value: {
              show: true,
              color: "#fff",   // 👈 controls the numeric value color
            },
            total: {
              show: true,
              label: "Total",
              fontSize: "16px",
              color: "#fff",   // 👈 this controls the word "Total"
              fontWeight: 600,
              formatter: (w: any) => {
                return (w.globals.seriesTotals as number[])
                  .reduce((a: number, b: number) => a + b, 0)
                  .toString();
              },
            },
          },
        },
      },
    },

    stroke: {
      show: true,
      width: 4,
      colors: ["#1F1F1F"]
    }
  };

  const series: number[] = [
    gatewayStats?.airtel_money?.percentage ?? 0,
    gatewayStats?.mpamba?.percentage ?? 0,
    gatewayStats?.paypal?.percentage ?? 0,
    gatewayStats?.stripe?.percentage ?? 0,
  ];

  return (
    <div className="bg-transparent p-6 rounded-lg">
      <Chart options={options} series={series} type="donut" height={280} />
    </div>
  );
};

export default GatewayDistributionChart;
